import * as Actions from '../actions';

const initialState = {
    assignmentListLoadedAfterSave: true,
    repullAssignment: false,
    copiedAssignment: false,
    copied_from_id: 0,
    NewAssignmentName: '',
    NeedToResetRTE: false,
    assignmentList: [],
    listLoaded: false,
    assignmentListSearchable: {
        companies: [],
        labels: [],
        courses: [],
        lessons: []
    },
    currentAssignment: {
        header: {
            assignment_id: 0,
            AssignmentName: '',
            AssignmentDescription: '',
            AssignmentContent: '',
            MinScore: 0,
            TotalScore: 100,
            Active: 1,
            CreateAuthID: 0,
            LastEditAuthID: 0,
            CreationDate: '',
            LastEditDate: '',
            Color: '#F3F1F0',
            IsGradable: 0,
            CopiedFromID: 0,
            IsLocked: 0,
            LockedByAuthID: 0
        },
        assetList: [],
        labels: [],
        newAssignmentAssets: []
    },
    editInfo: {
        CreateAuthEmail: '',
        LastEditAuthEmail: '',
        CreationDate: '',
        LastEditDate: ''
    },
    isAssignmentLoaded: false,
    allLessons: [],
    currentAssignmentLessonList: [],
    lessonSearch: '',
    allQuizzes: [],
    currentAssignmentQuizList: [],
    quizSearch: '',
    events: [],
    event_usage: {
        event_list: [],
        is_event_used: false,
    },
    companies: [],
    allCompanies: [],
    companySearch: ''
}

const assignmentReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_ASSIGNMENT_LOADED):
            {
                if (action.payload) {
                    return {
                        ...state,
                        isAssignmentLoaded: action.payload,
                    }
                } else {
                    // reset to default state
                    return {
                        ...initialState
                    }
                }
            }

        case (Actions.GET_ASSIGNMENT):
            {
                console.log(action.payload)
                if (!action.payload) {
                    return {
                        ...state,
                    currentAssignment: { header: {AssignmentName: 'placeholder'}, assetList: [] },
                    NewAssignmentName: 'placeholder',
                    isAssignmentLoaded: true,
                    }
                }
                return {
                    ...state,
                    currentAssignment: { ...action.payload, labels: action.payload.header.labels },
                    NewAssignmentName: action.payload.header.AssignmentName + ' - Copy',
                    isAssignmentLoaded: true,
                };
            }

        case (Actions.GET_ASSIGNMENT_EDIT_INFO):
            {
                return {
                    ...state,
                    editInfo: {
                        ...action.payload
                    }
                }
            }

        case (Actions.ACTIVATE_ASSIGNMENT):
            {
                return {
                    ...state,
                    currentAssignment: {
                        ...state.currentAssignment,
                        header: {
                            ...state.currentAssignment.header,
                            Active: 1
                        }
                        
                    }
                }
            }

        case (Actions.GET_ASSIGNMENT_ASSET_LIST):
            {
                const a_id = state.currentAssignment.header.assignment_id;

                if (a_id === 0) {
                    const newAssetList = state.currentAssignment.newAssignmentAssets.concat(action.payload.assetInsertResponse);
                    const new_asset_ids = newAssetList.map(a => a.insert_id);
                    const filtered_assets = action.payload.responseData.filter(a => new_asset_ids.includes(a.header.asset_id));

                    return {
                        ...state,
                        currentAssignment: {
                            ...state.currentAssignment,
                            assetList: filtered_assets,
                            newAssignmentAssets: state.currentAssignment.newAssignmentAssets.concat(action.payload.assetInsertResponse)
                        }
                    }
                }
                else {
                    return {
                        ...state,
                        currentAssignment: {
                            ...state.currentAssignment,
                            assetList: action.payload.responseData,
                            newAssignmentAssets: []
                        }
                    }
                }

            }
        case (Actions.UPDATE_ASSIGNMENT_LIST_LOADED):
            {
                return {
                    ...state,
                    assignmentListLoadedAfterSave: action.payload
                }
            }

        case (Actions.DELETE_ASSIGNMENT):
            {
                return {
                    ...state,
                    listLoaded: false,
                    currentAssignment: { ...initialState.currentAssignment, assignment_loaded: false },
                };
            }

        case (Actions.GET_ASSIGNMENT_LIST):
            {
                return {
                    ...state,
                    listLoaded: true,
                    assignmentList: action.payload.assignmentList.assignmentList,
                    assignmentListLoadedAfterSave: action.payload.call_location === 'list' ? state.assignmentListLoadedAfterSave : true,
                    assignmentListSearchable: {
                        companies: action.payload.assignmentList.searchData.companies,
                        labels: action.payload.assignmentList.searchData.labels,
                        courses: action.payload.assignmentList.searchData.courses,
                        lessons: action.payload.assignmentList.searchData.lessons
                    },
                };
            }

        case (Actions.UPDATE_ASSIGNMENT_FORM):
            {
                return {
                    ...state,
                    currentAssignment: {
                        ...state.currentAssignment,
                        header: {
                            ...state.currentAssignment.header,
                            ...action.payload
                        }
                    }
                }
            }

        case (Actions.UPDATE_ASSIGNMENT_LABELS):
            {
                return {
                    ...state,
                    currentAssignment: {
                        ...state.currentAssignment,
                        ...action.payload
                    }
                }
            }

        case (Actions.TOGGLE_COMPANY):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCompany = state.allCompanies.filter((c) => c.id === action.payload.company.id)
                    return {
                        ...state,
                        companies: state.companies.concat(newCompany)
                    }
                }
                else {
                    return {
                        ...state,
                        companies: state.companies.filter((c) => c.id !== action.payload.company.id)
                    }
                }
            }
        case (Actions.COMPANY_UPDATE_SEARCH):
            {
                return {
                    ...state,
                    companySearch: action.payload
                }
            }

        case (Actions.GET_RELATED_DATA):
            {
                const { lessons, quizzes, events, deleteAllowed, copiedAssignment, event_usage } = action.payload;

                return {
                    ...state,
                    currentAssignmentLessonList: lessons,
                    currentAssignmentQuizList: quizzes,
                    events: events,
                    deleteAllowed: deleteAllowed,
                    copiedAssignment: copiedAssignment,
                    event_usage: event_usage,
                    companies: action.payload.companies,
                    allCompanies: action.payload.allCompanies
                }
            }

        // Lesson Relation
        case (Actions.GET_ALL_LESSONS):
            {
                return {
                    ...state,
                    allLessons: action.payload.lessonList
                }
            }

        case (Actions.GET_COMPANY_LIST):
            {
                return {
                    ...state,
                    allCompanies: action.payload.map(c => {
                        return {
                            ...c,
                            label: c.CompanyName,
                            id: c.company_id
                        }
                    })
                }
            }
        case (Actions.TOGGLE_LESSON):
            {
                if (action.payload.action_type === 'ADD') {
                    let newLesson = state.allLessons.filter((lesson) => lesson.lesson_id === action.payload.lesson.id)
                    return {
                        ...state,
                        currentAssignmentLessonList: state.currentAssignmentLessonList.concat(newLesson)
                    }
                }
                else {
                    return {
                        ...state,
                        currentAssignmentLessonList: state.currentAssignmentLessonList.filter((lesson) => lesson.lesson_id !== action.payload.lesson.id)
                    }
                }
            }

        case (Actions.LESSON_UPDATE_SEARCH):
            {
                return {
                    ...state,
                    lessonSearch: action.payload
                }
            }

        // Quiz Relation

        case (Actions.GET_ALL_QUIZZES):
            {
                return {
                    ...state,
                    allQuizzes: action.payload.quizList
                }
            }

        case (Actions.TOGGLE_QUIZ):
            {
                if (action.payload.action_type === 'ADD') {
                    let newQuiz = state.allQuizzes.filter((quiz) => quiz.quiz_id === action.payload.quiz.id)
                    return {
                        ...state,
                        currentAssignmentQuizList: state.currentAssignmentQuizList.concat(newQuiz)
                    }
                }
                else {
                    return {
                        ...state,
                        currentAssignmentQuizList: state.currentAssignmentQuizList.filter((quiz) => quiz.quiz_id !== action.payload.quiz.id)
                    }
                }
            }

        case (Actions.QUIZ_UPDATE_SEARCH):
            {
                return {
                    ...state,
                    quizSearch: action.payload
                }
            }

        case (Actions.CREATE_COPY):
            {
                return {
                    ...state,
                    copy: true,
                    copied_from_id: action.payload,
                    NeedToResetRTE: true,
                    currentAssignment: {
                        ...state.currentAssignment,
                        header: {
                            ...state.currentAssignment.header,
                            assignment_id: 0,
                            AssignmentName: '',
                            CopiedFromID: action.payload
                        }
                    },
                    currentAssignmentQuizList: state.currentAssignmentQuizList.map(quiz => {
                        return {
                            ...quiz,
                            assignment_quiz_rel_id: null
                        }
                    })
                }
            }

        case (Actions.UPDATE_RTE):
            {
                return {
                    ...state,
                    NeedToResetRTE: false
                }
            }

        case (Actions.TOGGLE_ASSIGNMENT_REPULL):
            {
                return {
                    ...state,
                    repullAssignment: action.payload
                }
            }

        case (Actions.UPDATE_NEW_ASSIGNMENT_NAME):
            {
                return {
                    ...state,
                    NewAssignmentName: action.payload
                }
            }

        case (Actions.LOCK_ASSIGNMENT):
            {
                return {
                    ...state,
                    currentAssignment: {
                        ...state.currentAssignment,
                        header: {
                            ...state.currentAssignment.header,
                            IsLocked: 1,
                            LockedByAuthID: action.payload
                        }
                    }
                }
            }

        case (Actions.UNLOCK_ASSIGNMENT):
            {
                return {
                    ...state,
                    currentAssignment: {
                        ...state.currentAssignment,
                        header: {
                            ...state.currentAssignment.header,
                            IsLocked: 0,
                            LockedByAuthID: 0
                        }
                    }
                }
            }
        case (Actions.UPDATE_ASSET_NAME):
            {
                return {
                    ...state,
                    currentAssignment: {
                        ...state.currentAssignment,
                        assetList: state.currentAssignment.assetList.map(asset => {
                            if (asset.header.asset_id === action.payload.asset_id) {
                                return {
                                    ...asset,
                                    header: {
                                        ...asset.header,
                                        AssetNewName: action.payload.newName,
                                        UneditedNewName: action.payload.saved ? action.payload.newName :asset.header.UneditedNewName
                                    }       
                                }
                            }
                            return asset
                        })
                    }
                }
            }
        default:
            {
                return state;
            }
    }
}

export default assignmentReducer;


// WEBPACK FOOTER //
// src/main/content/assignment/store/reducers/assignment.reducer.js